//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedObjects.js";
import "../no/Object.js";
import "../no/BasePart.js";
let d=[[],[[["udo_class"],"CreateUserDefinedObject",{R_:{udo:"UserDefinedObjects.UserDefinedObject"}},1,0],[["udo_class","num_udos"],"GetUdosOfClass",{R_:{udos:"UserDefinedObjects.UserDefinedObject[]"}},1,0],[["link_object","link_type"],"IsObjectLinkable",{R_:{linkable:''}},2,0],[["link_object"],"IsObjectLinkedToUserDefinedObject",{R_:{is_linked:''}},1,0],[["link_object","num_links"],"GetLinksToObject",{R_:{links:""}},1,0],[["link_object"],"IsObjectOwnedByUserDefinedObject",{R_:{is_linked:''}},1,0],[["link_object"],"GetOwningUserDefinedObject",{R_:{owning_udo:"UserDefinedObjects.UserDefinedObject"}},1,0]],[]];
SPLM.UserDefinedObjects.UserDefinedObjectManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.UserDefinedObjects.UserDefinedObjectManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.UserDefinedObjects.UserDefinedObjectManager.LinkedUdoDefinition = class{
    constructor(link_type,associated_udo,status){
        this.link_type=link_type;this.associated_udo=associated_udo;this.status=status;}
    get LinkType(){return this.link_type}
    set LinkType(val){this.link_type = val}
    get AssociatedUdo(){return this.associated_udo}
    set AssociatedUdo(val){this.associated_udo = val}
    get Status(){return this.status}
    set Status(val){this.status = val}
};

export default SPLM;